import { BankAccountDetailsStatus } from '@40seas/entities/bank-account';
import { EnumColor } from '@40seas/frontend/common/providers';

export const bankAccountStatusColorMapping = {
    [BankAccountDetailsStatus.Inactive]: 'error',
    [BankAccountDetailsStatus.Active]: 'success',
} as { [key in BankAccountDetailsStatus]: EnumColor };
